const css = `.y5TPta__userList{transition:opacity .2s linear}.y5TPta__userList.y5TPta__loading{opacity:.5}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"userList":"y5TPta__userList","loading":"y5TPta__loading"};
